export const STAY_CATEGORIES = {
  hotel: "Hôtel",
  furnished_apartment: "Appartement meublé",
  studio: "Studio meublé",
  residence: "Résidence hôtelière",
  furnished_villa: "Villa meublée",
  guest_house: "Maison d'hôtes",
  corporate_housing: "Logement d'entreprise",
};

export const STAY_EQUIPMENT = [
  "Wi-Fi", "Climatisation", "Parking", "Petit-déjeuner", "Navette aéroport",
  "Ménage", "Cuisine équipée", "Piscine", "Salle de sport", "Sécurité 24/7",
  "Groupe électrogène", "Accessibilité PMR", "Télévision", "Eau chaude",
];

